import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppService } from '@app/app.service';
import { EmitService } from '@app/ts/services/emit.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,private appService : AppService,private commonservice:CommonService,private http: HttpClient,private emitService: EmitService) {
  }
  routerPermission: any;
  canActivate(route: ActivatedRouteSnapshot,): Observable<boolean>|Promise<boolean>|boolean {
    let cookieExist = this.commonservice.getCookie(environment.loginCookie);
     console.log(cookieExist)
    if(cookieExist) {
      if(JSON.parse(this.commonservice.decrypt(decodeURIComponent((cookieExist)))).instanceId!=JSON.parse(this.commonservice.decrypt(decodeURIComponent(this.commonservice.getCookie(environment.instanceCookie)))).instanceId)
          this.commonservice.logout();
    }
   
    
    if (route['_routerState'].url == '/auth/login') {
      console.log('in auth guard1')
      if (cookieExist == "") {
        console.log('no ccokie')
        return true;
      }
        
      else{
        console.log('routed to dashboard')
        this.router.navigate(['/dashboard']) 
      }
        
    }
    // else if (route['_routerState'].url == '/autologin' || route['_routerState'].url.includes('id_token')) {
    //   return true;
    // }
    else{
      console.log('in auth guard2')
      if (cookieExist == "") 
        localStorage.getEncryptedItem('isSSOLogin') == 'false' ? this.router.navigate(['/auth/login']) : this.router.navigate(['/autologin'])
      else
        return true;
    }
   
    
  }

  private tokenExpired(token) {
    let cookieExpiredTime = JSON.parse(token)
    return new Date(cookieExpiredTime[environment.tokenExpireTime]).getTime() < new Date().getTime();
  }
  
}
